import React from "react";
import Select from "react-select";
import { Modal, Form, Button } from "@themesberg/react-bootstrap";
import { useTranslation } from "react-i18next";

const InvoiceTypeCell = ({
  claim,
  invoiceTypes,
  setInvoiceTypes,
  setActiveClaimId,
  setShowCustomModal,
  setCustomInvoiceTypes,
  showCustomModal,
  customInvoiceTypes,
  activeClaimId,
}) => {
  const { t } = useTranslation();

  const options = [
    { value: "Delivery good", label: <span>📦 {t("invoiceType.deliveryGood")}</span> },
    { value: "Service", label: <span>🛠️ {t("invoiceType.services")}</span> },
    { value: "Purchase", label: <span>🛒 {t("invoiceType.purchase")}</span> },
    { value: "Agreement", label: <span>📄 {t("invoiceType.agreement")}</span> },
    { value: "Rental", label: <span>🏠 {t("invoiceType.rental")}</span> },
    { value: "custom", label: <span>✏️ {t("customother")}</span> },
  ];

  const handleChange = (selectedOption) => {
    if (!claim?._id) return;

    if (selectedOption?.value === "custom") {
      setActiveClaimId(claim._id); // which row triggered it
      setShowCustomModal(true); // open modal
    } else {
      setInvoiceTypes((prev) => ({
        ...prev,
        [claim._id]: selectedOption?.value || "",
      }));
    }
  };

  return (
    <td>
      <Select
      
        options={options}
        value={
          options.find((o) => o.value === invoiceTypes[claim._id]) ||
          (invoiceTypes[claim._id]
            ? { value: invoiceTypes[claim._id], label: invoiceTypes[claim._id] }
            : null)
        }
        onChange={handleChange}
        isDisabled={claim.status !== "Waiting for Admin Action"}
        placeholder={t("invoiceType.select")}
        classNamePrefix="react-select"
         menuPortalTarget={document.body} 
         
        styles={{
          control: (base, state) => ({
            ...base,
            minHeight: "32px",
            width: "205px",
            fontSize: "14px",
            borderRadius: "8px",
            boxShadow: state.isFocused ? "0 0 0 1px #4f46e5" : base.boxShadow,
            borderColor: state.isFocused ? "#4f46e5" : base.borderColor,
            "&:hover": { borderColor: "#4f46e5" },
          }),
          option: (base, state) => ({
            ...base,
            fontSize: "14px",
            padding: "6px 12px",
            backgroundColor: state.isSelected
              ? "#4f46e5"
              : state.isFocused
              ? "#e0e7ff"
              : "white",
            color: state.isSelected ? "white" : "black",
          }),
          singleValue: (base) => ({
            ...base,
            fontSize: "14px",
            color: "#111827",
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: "14px",
            color: "#6b7280",
          }),
               menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />

      {/* Custom Modal */}
      <Modal
        show={showCustomModal}
        backdrop={false}
        onHide={() => setShowCustomModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("invoiceType.customTitle") || "Enter Custom Invoice Type"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            as="textarea"
            rows={3}
            value={customInvoiceTypes?.[activeClaimId] || ""}
            onChange={(e) => {
              const value = e.target.value;
              setCustomInvoiceTypes((prev) => ({
                ...prev,
                [activeClaimId]: value,
              }));
            }}
            placeholder={t("invoiceType.customPlaceholder") || "Write your custom invoice type here..."}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
            {t("cancel") || "Cancel"}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setInvoiceTypes((prev) => ({
                ...prev,
                [activeClaimId]: customInvoiceTypes[activeClaimId] || "Custom",
              }));
              setShowCustomModal(false);
            }}
          >
            {t("save") || "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </td>
  );
};

export default InvoiceTypeCell;
